import {
  GET_OVERVIEW_PROVINSI,
  GET_OVERVIEW_PROVINSI_SUCCESS,
  GET_OVERVIEW_PROVINSI_FAIL,
  GET_OVERVIEW_KABKOT,
  GET_OVERVIEW_KABKOT_SUCCESS,
  GET_OVERVIEW_KABKOT_FAIL,
  GET_OVERVIEW_KECAMATAN,
  GET_OVERVIEW_KECAMATAN_SUCCESS,
  GET_OVERVIEW_KECAMATAN_FAIL,
  GET_OVERVIEW_KELURAHAN,
  GET_OVERVIEW_KELURAHAN_SUCCESS,
  GET_OVERVIEW_KELURAHAN_FAIL,
  GET_OVERVIEW_RT_RW,
  GET_OVERVIEW_RT_RW_SUCCESS,
  GET_OVERVIEW_RT_RW_FAIL,
  GET_OVERVIEW_KOMISARIS_BASIS,
  GET_OVERVIEW_KOMISARIS_BASIS_SUCCESS,
  GET_OVERVIEW_KOMISARIS_BASIS_FAIL,
} from "./actionTypes";

const initialState = {
  dataOverviewProvinsi: {
    loading: false,
    error: false,
    data: null,
  },
  dataOverviewKabkot: {
    loading: false,
    error: false,
    data: null,
  },
  dataOverviewKecamatan: {
    loading: false,
    error: false,
    data: null,
  },
  dataOverviewKelurahan: {
    loading: false,
    error: false,
    data: null,
  },
  dataOverviewRtRw: {
    loading: false,
    error: false,
    data: null,
  },
  dataOverviewKomisarisBasis: {
    loading: false,
    error: false,
    data: null,
  },
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_OVERVIEW_PROVINSI:
      return {
        ...state,
        dataOverviewProvinsi: {
          ...state.dataOverviewProvinsi,
          loading: true,
          error: false,
        },
      };
    case GET_OVERVIEW_PROVINSI_SUCCESS:
      return {
        ...state,
        dataOverviewProvinsi: {
          ...state.dataOverviewProvinsi,
          loading: false,
          error: false,
          data: action.payload,
        },
      };
    case GET_OVERVIEW_PROVINSI_FAIL:
      return {
        ...state,
        dataOverviewProvinsi: {
          ...state.dataOverviewProvinsi,
          loading: false,
          error: action.payload,
        },
      };
    case GET_OVERVIEW_KABKOT:
      return {
        ...state,
        dataOverviewKabkot: {
          ...state.dataOverviewKabkot,
          loading: true,
          error: false,
        },
      };
    case GET_OVERVIEW_KABKOT_SUCCESS:
      return {
        ...state,
        dataOverviewKabkot: {
          ...state.dataOverviewKabkot,
          loading: false,
          error: false,
          data: action.payload,
        },
      };
    case GET_OVERVIEW_KABKOT_FAIL:
      return {
        ...state,
        dataOverviewKabkot: {
          ...state.dataOverviewKabkot,
          loading: false,
          error: action.payload,
        },
      };
    case GET_OVERVIEW_KECAMATAN:
      return {
        ...state,
        dataOverviewKecamatan: {
          ...state.dataOverviewKecamatan,
          loading: true,
          error: false,
        },
      };
    case GET_OVERVIEW_KECAMATAN_SUCCESS:
      return {
        ...state,
        dataOverviewKecamatan: {
          ...state.dataOverviewKecamatan,
          loading: false,
          error: false,
          data: action.payload,
        },
      };
    case GET_OVERVIEW_KECAMATAN_FAIL:
      return {
        ...state,
        dataOverviewKecamatan: {
          ...state.dataOverviewKecamatan,
          loading: false,
          error: action.payload,
        },
      };
    case GET_OVERVIEW_KELURAHAN:
      return {
        ...state,
        dataOverviewKelurahan: {
          ...state.dataOverviewKelurahan,
          loading: true,
          error: false,
        },
      };
    case GET_OVERVIEW_KELURAHAN_SUCCESS:
      return {
        ...state,
        dataOverviewKelurahan: {
          ...state.dataOverviewKelurahan,
          loading: false,
          error: false,
          data: action.payload,
        },
      };
    case GET_OVERVIEW_KELURAHAN_FAIL:
      return {
        ...state,
        dataOverviewKelurahan: {
          ...state.dataOverviewKelurahan,
          loading: false,
          error: action.payload,
        },
      };
    case GET_OVERVIEW_RT_RW:
      return {
        ...state,
        dataOverviewRtRw: {
          ...state.dataOverviewRtRw,
          loading: true,
          error: false,
        },
      };
    case GET_OVERVIEW_RT_RW_SUCCESS:
      return {
        ...state,
        dataOverviewRtRw: {
          ...state.dataOverviewRtRw,
          loading: false,
          error: false,
          data: action.payload,
        },
      };
    case GET_OVERVIEW_RT_RW_FAIL:
      return {
        ...state,
        dataOverviewRtRw: {
          ...state.dataOverviewRtRw,
          loading: false,
          error: action.payload,
        },
      };
    case GET_OVERVIEW_KOMISARIS_BASIS:
      return {
        ...state,
        dataOverviewKomisarisBasis: {
          ...state.dataOverviewKomisarisBasis,
          loading: true,
          error: false,
        },
      };
    case GET_OVERVIEW_KOMISARIS_BASIS_SUCCESS:
      return {
        ...state,
        dataOverviewKomisarisBasis: {
          ...state.dataOverviewKomisarisBasis,
          loading: false,
          error: false,
          data: action.payload,
        },
      };
    case GET_OVERVIEW_KOMISARIS_BASIS_FAIL:
      return {
        ...state,
        dataOverviewKomisarisBasis: {
          ...state.dataOverviewKomisarisBasis,
          loading: false,
          error: action.payload,
        },
      };

    default:
      return state;
  }
};

export default reducer;
